// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ytunnus: CountryValidator<"FI"> = createValidator(
  "fi.ytunnus",
  73,
);

export default ytunnus;
export const compact = ytunnus.compact;
export const format = ytunnus.format;
export const validate = ytunnus.validate;
export const generate = (): string =>
  ytunnus.generate?.() ??
  (() => {
    throw new Error(
      "Validator fi.ytunnus cannot generate values",
    );
  })();
